import { SourceType } from 'module/api/filter/types';
import { FilterGroupType } from 'module/types/filter-field/grouped-filter/group';
import { ReactComponent as FormulaIcon } from 'module/ui/assets/svgs/formula.svg';
import { ReactComponent as PhaseIcon } from 'module/ui/assets/svgs/phase-icon-without-fill.svg';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import {
  faBuilding,
  faCalendar,
  faClock,
  faListCheck,
  faPiggyBank,
  faReceipt,
  faTools,
  faUser,
  faSignal,
} from '@fortawesome/pro-regular-svg-icons';

export const iconForGroupedFilter = {
  [FilterGroupType.Task]: <FontAwesomeIcon icon={faListCheck} />,
  [FilterGroupType.Project]: <FontAwesomeIcon icon={faListCheck} />,
  [FilterGroupType.Phase]: <PhaseIcon fill="currentColor" />,
  [FilterGroupType.User]: <FontAwesomeIcon icon={faUser} />,
  [FilterGroupType.Timesheet]: <FontAwesomeIcon icon={faClock} />,
  [FilterGroupType.Financial]: <FontAwesomeIcon icon={faPiggyBank} />,
  [FilterGroupType.Allocations]: <FontAwesomeIcon icon={faClock} />,
  [FilterGroupType.Utilisations]: <FontAwesomeIcon icon={faClock} />,
  [FilterGroupType.Role]: <FontAwesomeIcon icon={faClock} />,
  [FilterGroupType.Skill]: <FontAwesomeIcon icon={faTools} />,
  [FilterGroupType.Invoice]: <FontAwesomeIcon icon={faReceipt} />,
  [FilterGroupType.Company]: <FontAwesomeIcon icon={faBuilding} />,
  [FilterGroupType.Formula]: <FormulaIcon />,
  [FilterGroupType.Meeting]: <FontAwesomeIcon icon={faCalendar} />,
  [FilterGroupType.Signal]: <FontAwesomeIcon icon={faSignal} />,
};

export const filterTypeForSourceType = {
  [SourceType.Task]: FilterGroupType.Task,
  [SourceType.Project]: FilterGroupType.Project,
  [SourceType.Phase]: FilterGroupType.Phase,
  [SourceType.User]: FilterGroupType.User,
  [SourceType.Timesheet]: FilterGroupType.Timesheet,
  [SourceType.Financial]: FilterGroupType.Financial,
  [SourceType.Role]: FilterGroupType.Role,
  [SourceType.Invoice]: FilterGroupType.Invoice,
  [SourceType.Company]: FilterGroupType.Company,
  [SourceType.Formula]: FilterGroupType.Formula,
  [SourceType.Meeting]: FilterGroupType.Meeting,
  [SourceType.Signal]: FilterGroupType.Signal,
};
export const sourceTypeForFilterType = {
  [FilterGroupType.Task]: SourceType.Task,
  [FilterGroupType.Project]: SourceType.Project,
  [FilterGroupType.Phase]: SourceType.Phase,
  [FilterGroupType.User]: SourceType.User,
  [FilterGroupType.Timesheet]: SourceType.Timesheet,
  [FilterGroupType.Financial]: SourceType.Financial,
  [FilterGroupType.Role]: SourceType.Role,
  [FilterGroupType.Skill]: SourceType.User,
  [FilterGroupType.Invoice]: SourceType.Invoice,
  [FilterGroupType.Company]: SourceType.Company,
  [FilterGroupType.Formula]: SourceType.Formula,
  [FilterGroupType.Meeting]: SourceType.Meeting,
  [FilterGroupType.Signal]: SourceType.Signal,
};
